import { useEffect, useMemo, useState } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildAccountsRequest } from '@common/utils';

const useCanCreateProjectCompany = () => {
  const accountId = useCurrentAccountId();
  const [cantCreate, setCantCreate] = useState(false);

  const getAccountsRequest = useMemo(() => buildAccountsRequest(), []);

  const { data: accountsData } = useDataApi(...getAccountsRequest);

  useEffect(() => {
    if (!accountsData || !accountId) return;

    const accountData = accountsData?.results?.find(
      (acc) => acc.id === accountId
    );
    if (accountData.createCompanyAccessLevels?.length === 2)
      setCantCreate(false);
    else setCantCreate(true);
  }, [accountsData, accountId]);

  return cantCreate;
};

export default useCanCreateProjectCompany;
